import { Component } from '@angular/core';
import { ReplenishYourGoodBacteriaComponent } from '@components/consultation-request/upsells/replenish-your-good-bacteria/replenish-your-good-bacteria.component';

@Component({
  selector: 'app-replenish-your-good-bacteria-hemorrhoids',
  imports: [ReplenishYourGoodBacteriaComponent],
  templateUrl: './replenish-your-good-bacteria-hemorrhoids.component.html',
  styleUrl: './replenish-your-good-bacteria-hemorrhoids.component.scss',
})
export class ReplenishYourGoodBacteriaHemorrhoidsComponent {}
